import { useMutation } from '@tanstack/react-query';

import { EmailResendPayload } from '../../../../types/requests';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postResendVerifyEmail } from '../../requests/postResendVerifyEmail';

export const useResendVerifyEmail = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: EmailResendPayload) =>
      postResendVerifyEmail(constructPost, data),
  });
  return { resendVerifyEmail: mutateAsync, ...rest };
};
